import React from 'react';

interface RecordData {
  slNo: number;
  refNo: string;
  createdDate: string;
  department: string;
  location: string;
}

const sampleData: RecordData[] = [
  {
    slNo: 1,
    refNo: '#WRP002356895',
    createdDate: '05/10/2023',
    department: 'Electrical Maintenance',
    location: 'Switchgear Room',
  },
  {
    slNo: 2,
    refNo: '#WRP002356896',
    createdDate: '05/10/2023',
    department: 'Transformer Service',
    location: 'Transmission Line Tower 7',
  },
  {
    slNo: 3,
    refNo: '#WRP002356897',
    createdDate: '04/10/2023',
    department: 'Electrical Maintenance',
    location: 'Generator Room',
  },
  {
    slNo: 4,
    refNo: '#WRP002356898',
    createdDate: '03/10/2023',
    department: 'Emergency Response Team',
    location: 'Switchgear Room',
  },
  {
    slNo: 5,
    refNo: '#WRP002356899',
    createdDate: '03/10/2023',
    department: 'Emergency Response Team',
    location: 'Feeder Line Junction Box',
  },
  {
    slNo: 6,
    refNo: '#WRP002356811',
    createdDate: '03/10/2023',
    department: 'Electrical Maintenance',
    location: 'Generator Room',
  },
  {
    slNo: 7,
    refNo: '#WRP002359012',
    createdDate: '02/10/2023',
    department: 'Electrical Maintenance',
    location: 'Recloser Station',
  },
];

const ReportTable: React.FC = () => {
  return (
    <div className="p-6">
      <div className="overflow-x-auto rounded-lg shadow border border-gray-200">
        <table className="min-w-full text-sm text-left border rounded shadow">
          <thead className="text-gray-600 text-xs">
            <tr className="h-[45px]">
              <th className="px-4 py-3 border">Sl. No</th>
              <th className="px-4 py-3 border">Ref No.</th>
              <th className="px-4 py-3 border">Created Date</th>
              <th className="px-4 py-3 border">Department</th>
              <th className="px-4 py-3 border">Location</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {sampleData.map((item) => (
              <tr key={item.slNo} className="cursor-pointer hover:bg-gray-50 transition">
                <td className="px-4 py-3 border">{item.slNo}</td>
                <td className="px-4 py-3 text-blue-700 font-medium border">{item.refNo}</td>
                <td className="px-4 py-3 border">{item.createdDate}</td>
                <td className="px-4 py-3 border">{item.department}</td>
                <td className="px-4 py-3 border">{item.location}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportTable;
